import { gql } from '@apollo/client';

export const UPDATE_SELECTED_LANGUAGE = gql`
mutation($record: UpdatePractitionerMeSelectedLanguageInput!)
{
    user {
        dashboardUser {
            updateMeSelectedLanguage(record: $record) {
                ok,
                error
                {
                    message,
                    code
                },
                resultId,
                result {
                    id,
                    firstName,
                    lastName,
                    email,
                    preferredLanguages,
                    selectedLanguage,
                }
            }
        }
    }
}`;